import '../Body.css';
import React from "react";

function About(props) {

    return (
        <div className="aboutPage">
        </div>
    )
}

export default About;